export default __webpack_public_path__ + "static/media/completed.0c4ecc09.svg";